import { render, staticRenderFns } from "./NewRecipeAdd.vue?vue&type=template&id=bba5ecd0"
import script from "./NewRecipeAdd.vue?vue&type=script&lang=js"
export * from "./NewRecipeAdd.vue?vue&type=script&lang=js"
import style0 from "./NewRecipeAdd.vue?vue&type=style&index=0&id=bba5ecd0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports